export default "__VITE_ASSET__lTZmcDSE__"